import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var propertyDetails = {
  name: "1821gv5",
  styles: "display:flex;flex-direction:column;gap:8px;"
};
export var addressLine1 = /*#__PURE__*/css(designTokenFonts.displaySmall);
export var addressLine2 = /*#__PURE__*/css();
export var features = {
  name: "1gxeym5",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;gap:8px;"
};
export var relationship = {
  name: "yd8sa2",
  styles: "display:flex;flex-direction:column;gap:16px;"
};
export var relationshipHeading = /*#__PURE__*/css(designTokenFonts.displaySmall);
export var relationshipText = /*#__PURE__*/css();